<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-title>
            Encuesta Termómetro {{ session.route }}
          </v-card-title>
          <v-card-text>
            <div>
              <div class="text-overline font-weight-light">Fecha de la sesión</div>
              <div>{{ filter.formatDate(session.date, 1) }}</div>
            </div>
            <div>
              <div class="text-overline font-weight-light">Grupo</div>
              <div>Grupo {{ session.group }}</div>
            </div>
            <div>
              <div class="text-center text-h5">¿Cómo te sentiste durante la sesión de hoy?</div>
              <v-row no-gutters>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(0)">
                    <h1>😴</h1>
                    <h4>0 - Aburrido(a)</h4>
                  </v-btn>
                </v-col>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(1)">
                    <h1>😥</h1>
                    <h4>1 - Preocupado(a)</h4>
                  </v-btn>
                </v-col>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(2)">
                    <h1>🤔</h1>
                    <h4>2 - Pensativo(a)</h4>
                  </v-btn>
                </v-col>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(3)">
                    <h1>😮</h1>
                    <h4>3 - Sorprendido(a)</h4>
                  </v-btn>
                </v-col>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(4)">
                    <h1>😎</h1>
                    <h4>4 - Confiado(a)</h4>
                  </v-btn>
                </v-col>
                <v-col class="pa-3">
                  <v-btn class="w-100" color="primary" size="large" @click="send(5)">
                    <h1>😍</h1>
                    <h4>5 - Encantado(a)</h4>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Encuesta de Satisfacción</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="back()"/>
        </div> 
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Encuesta de Satisfacción</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
      </v-sheet>
    </v-dialog>

    <!-- failed -->
    <v-dialog v-model="failed" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          Esta sesión no tiene encuesta de satisfacción habilitada.
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import axios from 'axios';
  import Params from '@/models/params';
  import Session from '@/models/session';
  import Filters from '@/models/filters';
  import { ref, reactive, onMounted } from "vue";
  import { useRoute } from 'vue-router';

  const route = useRoute();

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const params = ref(new Params)  
  const session = ref(new Session)
  const filter = ref(new Filters)

  const process = ref(true);
  const failed = ref(false);

  session.value.code = route.params.session;

  async function load(){
    const frm = new FormData;
    frm.append("action","cargar");
    frm.append("sesion",session.value.code);
    frm.append("tipo","T");
    const result = await eject(frm);
    process.value = false;
    if(result.data.length > 0){
      session.value.setDataAsisstance(result.data[0]);
    }else{
      failed.value = true;
    }
  }

  async function send(value){
    process.value = true;
    const frm = new FormData;
		frm.append("action", "termometro");
    frm.append("valor", value);
    frm.append("sesion", session.value.code);
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      success.text = "Encuesta registrada correctamente.";
      success.state = true;
    }else{
      error.text = "Hubo un error al intentar registrar la encuesta.";
      error.state = true;
    }
  }

  function back(){
    window.history.back();
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'encuesta.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  })
</script>